import { useMsal } from '@azure/msal-react';
import { Dialog, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BrandProps, ClientConfig } from '../../../../clientConfig';
import { PromotionState } from '../../../../types/reactTypes';
import { ClientConfigContext } from '../../../clientConfigContext';
import useDeviceWidth from '../../../hooks/useDeviceWidth';
import { useValidatedUrl } from '../../../hooks/useValidatedUrl';
import { AppPromotionEvents, buildAppPromotionEventProps, sendEvent } from '../../../services/amplitudeClient';
import getAccessToken from '../../../util/getAccessToken';
import { redirectWithSoftLogout } from '../../../util/sessionTimeout';
import withLogger, { ComponentLoggerProps } from '../../HOC/WithLogger';
import { AppPromImage } from './AppPromImage';
import { AppPromotionControl } from './AppPromotionControl';

const AppPromotionComponent = ({ brandInfo, log }: BrandProps & ComponentLoggerProps) => {
    const location = useLocation<PromotionState>();
    const [jwt, setJwt] = useState('');
    const { isSmallWidth } = useDeviceWidth();
    const { instance, accounts } = useMsal();
    const { b2cTenantConfig } = useContext<ClientConfig>(ClientConfigContext);
    const validateRedirectUrl = useValidatedUrl();

    const handleRedirect = async () => {
        const eventProps = buildAppPromotionEventProps(AppPromotionEvents.SKIP_APP_PROMOTION, brandInfo.name ?? brandInfo.brand);
        sendEvent(eventProps, jwt);
        redirectWithSoftLogout(instance, location.state?.redirectUrl, validateRedirectUrl);
    };

    useEffect(() => {
        getAccessToken(instance, accounts, b2cTenantConfig.scopes, log).then((jwt) => {
            setJwt(jwt);
            const eventProps = buildAppPromotionEventProps(AppPromotionEvents.VIEW_APP_PROMOTION, brandInfo.name ?? brandInfo.brand);
            sendEvent(eventProps, jwt);
        });
    }, []);

    return (
        <Dialog className='PromotionDialog' open={true}>
            <IconButton className={`closeButton ${isSmallWidth ? 'hidden' : ''}`} aria-label='close' onClick={handleRedirect}>
                <CloseIcon fontSize='large' htmlColor={brandInfo.promotion?.brandColor} />
            </IconButton>
            <DialogContent>
                <div className='promotionContainer'>
                    <AppPromImage brandInfo={brandInfo} />
                    <AppPromotionControl brandInfo={brandInfo} />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export const AppPromotion = withLogger(AppPromotionComponent, { eventSource: 'AppPromotion' });
